module.exports = __webpack_public_path__ + "static/media/boop_vr.4dbea190.png";